import { MonthZeroBased } from '@deltasierra/shared';

export function getMonth(date: Date): MonthZeroBased {
    return date.getMonth() as MonthZeroBased;
}
